import SectionPage from "@/components/common/section-page";

import {Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList,} from "@/components/ui/breadcrumb"
import CardTitle from "@/components/common/card-title";
import AwesomeCard from "@/components/common/awesome-card";
import {cn} from "@/lib/utils";

const langageDeRue = [
    {
        "expression": "Akwaba",
        "definition": "Bienvenue, bonne arrivée"
    },
    {
        "expression": "Aaaaaah yakoi",
        "definition": "Expression qui dénote l’exaspération."
    },
    {
        "expression": "Affairage",
        "definition": "Rumeur, ragot, commérage. (S’) affairer : ragoter, parler de. Un affairé (syn : un kpakpato) : une personne qui aime se mêler de ce qui ne la regarde pas."
    },
    {
        "expression": "Annnhannnn",
        "definition": "Par cette onomatopée généralement bien appuyée, votre interlocuteur vous signifie que le message est enfin passé."
    },
    {
        "expression": "Atouh",
        "definition": "Marque d’affection. C’est ce qu’on dit quand on s’embrasse ou que l’on se prend affectueusement dans les bras par exemple."
    },
    {
        "expression": "Avoir des foutaises",
        "definition": "Exagérer,  » déconner  » (connotation négative)."
    },
    {
        "expression": "Avoir la bouche sucrée, faire sa bouche sucrée ",
        "definition": "Se montrer mielleux ou obséquieux, minauder, amadouer."
    },
    {
        "expression": "Avoir un son",
        "definition": "Avoir un scoop, une nouvelle ou une blague à partager."
    },
    {
        "expression": "(Être) bahi",
        "definition": "Etre malchanceux. Ex :  » Rien ne lui réussit, il est bahi « ."
    },
    {
        "expression": "Bara",
        "definition": "Travail."
    },
    {
        "expression": "Bédou",
        "definition": "Portefeuille"
    },
    {
        "expression": "Beou",
        "definition": "S’en aller, filer, foutre le camp. Ex :  » Beou en vitesse avant que je me fâche ! « "
    },
    {
        "expression": "Bien même ",
        "definition": "Sert à renforcer un énoncé affirmatif. Ex :  » Tu as préparé l’exposé ?  » /  » Bien même ! « ."
    },
    {
        "expression": "Blaguer",
        "definition": "Jouer un mauvais tour à quelqu’un, faire marcher, duper, rouler dans la farine. Ex :  » C’est quel faux marabout ça ? Il m’a blagué pour m’escroquer ! « "
    },
    {
        "expression": "Bramôgô",
        "definition": "Bra (du français  » bras « ) + môgô (du dioula,  » homme « ). Bras droit, ami, homme de confiance, confident."
    },
    {
        "expression": "Brouteur",
        "definition": "Cyber-escroc qui arnaque des mugus (pigeons) sur le Web et va ensuite flamber en boîte avec son argent mal acquis (version courte)."
    },
    {
        "expression": "Cadeau",
        "definition": "Gratuit. Ex :  » Faut prendre cadeau pardon !  » (C’est pour toi, c’est cadeau)."
    },
    {
        "expression": "Caler",
        "definition": "Squatter, être posé."
    },
    {
        "expression": "Ça fait deux jours !",
        "definition": "Ça fait un bail !"
    },
    {
        "expression": "Ça a coupé mon coeur !",
        "definition": "Ça m’a fichu une frousse monstre !"
    },
    {
        "expression": "Ça mange pour toi !",
        "definition": "Ça roule pour toi !"
    },
    {
        "expression": "Ça ment sur moi",
        "definition": "C’est chaud pour moi ; c’est dur, c’est compliqué."
    },
    {
        "expression": "Ça ne ment pas",
        "definition": "C’est de la bonne qualité applicable à un produit, un service ou autre dont on fait la promotion."
    },
    {
        "expression": "Ça va aller",
        "definition": "Expression incontournable de l’indéfectible optimisme ivoirien. On l’utilise au moins autant que  » Yako « , son alter-ego compassionnel."
    },
    {
        "expression": "C’est comment ?",
        "definition": "Alors, que se passe t’il/quelles sont les nouvelles/qu’est-ce que tu racontes de beau ? Expression panafricaine dont l’équivalent ivoirien est :  » On dit quoi ?  » –  » On est là ! « "
    },
    {
        "expression": "C’est doux dêh !",
        "definition": "Expression du contentement typiquement ivoirienne qui s’utilise à toutes les sauces : quand un plat est bon, quand on se sent bien, lorsque l’on passe un moment agréable."
    },
    {
        "expression": "C’est l’homme qui a peur sinon ya rien",
        "definition": "Ça va aller, il n’y a pas de raisons de s’inquiéter."
    },
    {
        "expression": "C’est le lass",
        "definition": "C’est la meilleure, c’est la goutte d’eau, il ne manquait plus que ça."
    },
    {
        "expression": "C’est mon comme ça",
        "definition": "C’est ma nature."
    },
    {
        "expression": "C’est quelle science ?",
        "definition": "C’est quoi ces histoires ?"
    },
    {
        "expression": "C’est quoi ? C’est quoi même ?",
        "definition": "Qu’est-ce que ça veut dire ? Qu’est-ce qui se passe ? Dénote la curiosité, la surprise, voire l’indignation."
    },
    {
        "expression": "Chap-chap ",
        "definition": "Très vite. Ex :  » Faut faire chap-chap on va go !  » (Dépêche-toi, on y va !)"
    },
    {
        "expression": "Chauffer le rognon de quelqu’un",
        "definition": "Le mettre en colère, lui taper sur les nerfs, l’indigner, l’écœurer. Ex :  » Les grèves intempestives chauffent trop mon rognon ! « . Synonyme :  » Mon gbêlê brûle  » (Je bous de colère)."
    },
    {
        "expression": "Chauffez le coin !",
        "definition": "Mettez l’ambiance ! Souvent utilisé comme une incitation à la bagarre ou à la danse."
    },
    {
        "expression": "Chicoter",
        "definition": "Fouetter et par extension, frapper."
    },
    {
        "expression": "Chôcô ",
        "definition": "Bien parler français ou parler avec un niveau de langue soutenu. Par extension, être beau, faire le beau, être in, à la mode. Ex :  » Tu chôcô dêh !  » (Tu te la pètes avec ton gros français !)."
    },
    {
        "expression": "Coeur mort ",
        "definition": "Trouillard, peureux. Antonyme : gros cœur."
    },
    {
        "expression": "Connaisseur connaît, gaou passe ",
        "definition": "Signifie que l’on a l’œil, l’expertise, que l’on est au fait,  » in « ."
    },
    {
        "expression": "Connaître façon/manière ",
        "definition": "Savoir y faire, s’y connaître, être compétent dans un domaine bien précis."
    },
    {
        "expression": "Daba",
        "definition": "Signifie frapper, taper, cogner une personne. Ex : Je vais te daba"
    },
    {
        "expression": "Dabali/badouko",
        "definition": "Action de manger ou repas."
    },
    {
        "expression": "Dahico",
        "definition": "Beuverie, saoulerie, cuite."
    },
    {
        "expression": "Décaler",
        "definition": "Danser."
    },
    {
        "expression": "Dêh !",
        "definition": "Exclamation. Ex :  » C’est doux dêh!  » (C’est bon, c’est trop chic !)."
    },
    {
        "expression": "Désciencer",
        "definition": "Décourager, décevoir."
    },
    {
        "expression": "Diallo",
        "definition": "Propriétaire ou vendeur de boutique de quartier. Boutiquier"
    },
    {
        "expression": "Dja",
        "definition": "Tuer, mourir (au sens propre et figuré)"
    },
    {
        "expression": "Djagaille",
        "definition": "Cigarette. Ex :  » Donne-moi la djagaille  » (Donne-moi une cigarette). On peut aussi utiliser les termes  » fal « , ou  » bâton « ."
    },
    {
        "expression": "Djo/môgô :",
        "definition": "Un homme, un mec, un gar."
    },
    {
        "expression": "Doigter",
        "definition": "Montrer du doigt. Ex :  » Si je m’habille comme ça au village, les gens vont me doigter ! « "
    },
    {
        "expression": "Drap.  » Être en drap  »",
        "definition": "Être au courant de quelque chose –  » Y a pas drap !  » => Y a pas de problème ! –  » Y a drap sur elle/lui  » => Il/elle s’est mis dans un sale pétrin, dans… de beaux draps.  » Tu vas prendre drap  » => Tu vas prendre cher/Il va t’arriver malheur – Casser drap : dénoncer. Ex :  » Sa belle-sœur l’a surpris avec une fille. Elle a cassé drap « ."
    },
    {
        "expression": "Dye",
        "definition": "Saoul"
    },
    {
        "expression": " » En même temps est mieux  »",
        "definition": "Pas la peine de remettre à demain, autant agir sur-le-champ."
    },
    {
        "expression": "Enceinter",
        "definition": "Mettre enceinte, engrosser."
    },
    {
        "expression": "Enjaillement",
        "definition": "Attirance, amusement. Enjailler : plaire, attirer. Ex.  » Tu m’enjailles trop quoi  » => Tu me plais trop, je suis fan de toi –  » On va s’enjailler  » => On va passer du bon temps, s’amuser (dérivé de l’anglais enjoy). Être enjaillé : être amoureux, être en joie, enjoué.  » Enjaillement est dans ses dents  » => Il est raide dingue d’elle."
    },
    {
        "expression": "Entrer-coucher ",
        "definition": "Studio."
    },
    {
        "expression": "Être bec sucré : ",
        "definition": "Être gourmand(e), aimer les sucreries. Un bec sucré : un gourmand, une gourmande."
    },
    {
        "expression": "Être culottée ",
        "definition": "Avoir de grosses fesses."
    },
    {
        "expression": "Être sur le Web ",
        "definition": "Être célibataire, seul en amour, cœur à prendre."
    },
    {
        "expression": "Façon ",
        "definition": "Bizarre, qu’on a du mal à définir. Ex :  » Elle va encore se ramener avec une robe façon sac à patates !  » – Bizarrement, curieusement. Ex :  » Ce type ne me plaît pas : il me regarde toujours façon « ."
    },
    {
        "expression": "Faire farot-farot, faroter ",
        "definition": "Se pavaner, faire le beau. Terme qui s’applique tout particulièrement aux  » sapeurs « . Farotage : frime. Faroteur : frimeur."
    },
    {
        "expression": "Faux type, faux gars ",
        "definition": "Personne irresponsable, sur laquelle on ne peut pas compter, qui ne tient pas ses promesses, qui  » ne vaut rien  » ; hypocrite, ingrat, faux-jeton."
    },
    {
        "expression": "Fraya",
        "definition": "Fuir. Prendre la clé des champs, s’échapper. Ex :  » Les voleurs ont fraya en brousse ! «."
    },
    {
        "expression": "Fréquenter",
        "definition": "Aller à l’école, au lycée, à l’université. Ex :  » Tu fréquentes où ?  » (Dans quelle école/lycée/université tu es ?)."
    },
    {
        "expression": "Freshnie/gazelle",
        "definition": "Jolie jeune fille."
    },
    {
        "expression": "Gagner affaire ",
        "definition": "Avoir des ennuis, des histoires."
    },
    {
        "expression": "Gaou/brèzo/gnata ",
        "definition": "Péquenaud, looser de service"
    },
    {
        "expression": "Gâter",
        "definition": "Vanner, dire du mal, salir la réputation de quelqu’un. Ex :  » Ne gâte pas son nom ! « . Existe également ce que l’on appelle le  » gât-gât « , à savoir une sorte de joute verbale où le but est de vanner gentiment son interlocuteur et d’avoir le dernier mot ; ce petit jeu est surtout l’apanage des enfants."
    },
    {
        "expression": "Gazer",
        "definition": "Sortir, faire la fête."
    },
    {
        "expression": "Gbangban ",
        "definition": "Situation difficile, troubles, remue-ménage."
    },
    {
        "expression": "Gbayer ou gbaer  ",
        "definition": "Du bété. Signifie selon le contexte parler avec éloquence ou sécher les cours."
    },
    {
        "expression": "Gnaga : bagarre.",
        "definition": "Bagarre. Gnagasseur : bagarreur."
    },
    {
        "expression": "Gnanhi ",
        "definition": "Se dit d’une cougar, soit une femme d’un certain âge friande des  » petits pompiers  » (les hommes qui sortent avec ce genre de femmes)."
    },
    {
        "expression": "Go/biefrou/gomi/pey’ite ",
        "definition": "Fille (pendant féminin de  » gars « , que l’on entend également beaucoup). Par extension, go signifie également petite amie."
    },
    {
        "expression": "Grôtô ",
        "definition": "Homme riche (son aisance financière est généralement proportionnelle à la taille de son ventre. D’ailleurs en Côte d’Ivoire, si tu es gros et sans le sou, on t’appelle  » le gros « , alors que si tu es gros et riche, on t’appelle  » le boss « )"
    },
    {
        "expression": "Grouper ",
        "definition": "Se liguer contre quelqu’un ou se disputer quelque chose."
    },
    {
        "expression": "Hon hon",
        "definition": "Non non (n’insistez pas on vous dit !)."
    },
    {
        "expression": "Ijioh !",
        "definition": "Oh là là"
    },
    {
        "expression": "Il a fini avec ça ",
        "definition": "Il maîtrise trop bien son affaire."
    },
    {
        "expression": "J’emprunte le 11 ",
        "definition": "Je vais à pied (en référence au numéro de ligne imaginaire formé par les deux jambes)"
    },
    {
        "expression": "Je suis arrêté",
        "definition": "Je suis debout, je me tiens là, je suis là."
    },
    {
        "expression": "Je te dis ",
        "definition": "Marque l’assentiment résigné et/ou impuissant."
    },
    {
        "expression": "Kéchia/kessia ",
        "definition": "Diminutif de  » qu’est-ce qu’il y a « ."
    },
    {
        "expression": "Kpata",
        "definition": "Mot feminin, masculin pour exprimer la beauté extrême d’une personne."
    },
    {
        "expression": "Le jour de son jour ",
        "definition": "Son heure."
    },
    {
        "expression": "Le vieux, la vieille ",
        "definition": "Le père, la mère. À l’inverse de l’Occident, en Côte d’Ivoire, cette appellation a une connotation respectueuse et affectueuse. Par extension, on l’utilise aussi pour désigner un aîné, même s’il est âgé de quelques années de plus seulement."
    },
    {
        "expression": "Mal",
        "definition": "A l’excès, beaucoup, trop."
    },
    {
        "expression": "Même père même mère ",
        "definition": "Frère et sœur ou frère et frère issus des mêmes parents biologiques."
    },
    {
        "expression": "Moisi, piqué",
        "definition": "Fauché."
    },
    {
        "expression": "Opko !",
        "definition": "N’importe quoi !"
    },
    {
        "expression": "On est ensemble ",
        "definition": "Je te soutiens, je te comprends, il n’y a pas de problème, ça va aller."
    },
    {
        "expression": "Petite : maîtresse, amante. ",
        "definition": "Petite : maîtresse, amante."
    },
    {
        "expression": "Pian ",
        "definition": "Et tac"
    },
    {
        "expression": "Pissant môgô ou môgô pissant  ",
        "definition": "Du mot puissant + môgô (homme). Désigne un homme qui a des pouvoirs ou encore un homme qui est brave et s’illustre dans un domaine donné."
    },
    {
        "expression": "Quitte là ! ",
        "definition": "Fiche-moi le camp, dégage, laisse-moi tranquille !"
    },
    {
        "expression": "On s’attrape ",
        "definition": "On / se téléphone-on/ se fait une bouffe / se voit plus tard."
    },
    {
        "expression": "Qui est fou ?",
        "definition": "Exclamation qui correspond à / Mais qu’est-ce que tu crois ? / Tu me prends pour un imbécile ? /"
    },
    {
        "expression": "Petite ",
        "definition": "Maîtresse, amante."
    },
    {
        "expression": "Rentrer en brousse",
        "definition": "Disparaître de la circulation."
    },
    {
        "expression": "S’en fout la mort ",
        "definition": "Casse-cou."
    },
    {
        "expression": "S’en gnangner ",
        "definition": "S’en foutre."
    },
    {
        "expression": "Se fourrer ",
        "definition": "Rentrer sa chemise dans son pantalon."
    },
    {
        "expression": "Se têter ",
        "definition": "Entrevue tête-tête, se concerter en privé."
    },
    {
        "expression": "Ta bouche porte pas caleçon ",
        "definition": "Tu /aimes trop parler / ne sais pas te taire/ es une langue de vipère/ une grande gueule/ ne dis que des bêtises…"
    },
    {
        "expression": "Tantie/Tonton ",
        "definition": "Appellation d’une femme ou d’un homme plus âgé que soi àqui on souhaite témoigner son affection, son respect ou sa déférence."
    },
    {
        "expression": "Taper poteau ",
        "definition": "Dans le sens de rater un but. Échouer. En amour se prendre un vent."
    },
    {
        "expression": "Tchieéé ",
        "definition": "Signifie que l’on est dépassé par les événements."
    },
    {
        "expression": "Sciencer  ",
        "definition": "Réfléchir à quelque chose, bloquer sur quelque chose."
    },
    {
        "expression": "Faut sciencer  ",
        "definition": "Manière de demander pardon à son interlocuteur."
    },
    {
        "expression": "Ton papa ! Ta maman !",
        "definition": "Injure quasiment impardonnable qui appelle au minimum une réponse verbale"
    },
    {
        "expression": "Trouver son terminus ",
        "definition": "Trouver plus fort que soi, une rivale imbattable. Trouver l’amour de sa vie"
    },
    {
        "expression": "Tu me moyen pas ",
        "definition": "Tu n’es pas à ma hauteur, tu ne peux pas me battre"
    },
    {
        "expression": "Tchôkô-tchôkô",
        "definition": "Quoi qu’il arrive."
    },
    {
        "expression": "Tchrourrr ",
        "definition": "Exclamation marquant généralement l’exaspération, la colère, voire le mépris."
    },
    {
        "expression": "Togo",
        "definition": "Cent francs. 2 togos : deux cents francs,"
    },
    {
        "expression": "Un less ",
        "definition": "une chose sans importance."
    },
    {
        "expression": "Ya foye/foyi/fohi ",
        "definition": "Ce n’est rien, ce n’est pas grave, ça le fait !"
    },
    {
        "expression": "Ya pas son deux",
        "definition": "Il n’y a pas d’équivalent, il n’y en a pas deux pareils."
    },
    {
        "expression": "Ya quoi ?",
        "definition": "Qu’est-ce qui se passe, c’est quoi le problème ?"
    },
    {
        "expression": "Ya rien c’est propre ",
        "definition": "Rien à redire, c’est nickel, ça le fait."
    },
    {
        "expression": "Yako",
        "definition": "Exprime la compassion."
    },
    {
        "expression": "Yé dis ",
        "definition": "S’utilise pour insister, affirmer, renforcer un énoncé ou un argument."
    },
]

export default function Home() {

    return (
        <div className={"flex flex-col gap-6 pb-6 bg-slate-100"}>
            <CardTitle title={"Notre Langage de Rue"}
                       backgroundImgSrc={"/images/card-title/Notre-Langage-de-Rue.jpg"}/>

            {/* Breadcrumb */}
            <SectionPage sectionType="2xl">
                <div className={"flex justify-between items-center"}>
                    <Breadcrumb>
                        <BreadcrumbList>
                            <BreadcrumbItem>
                                <BreadcrumbLink href={"/"}>Notre Langage de Rue</BreadcrumbLink>
                            </BreadcrumbItem>
                        </BreadcrumbList>
                    </Breadcrumb>

                </div>
            </SectionPage>

            {/* Notre Langage de Rue */}
            <SectionPage sectionType="2xl">
                <AwesomeCard title={"Notre Langage de Rue"} className={"bg-white text-muted-foreground"}
                             titleClassName={"text-bleu-marine"}>
                    Quelques mots et expressions, issus du nouchi, langage populaire courant très utilisé en Côte
                    d’Ivoire. C’est un mélange de mots provenant de toutes les ethnies et également des nombreuses
                    langues des peuples résidents. De l’ébrié au dioula et au bété en passant par le français et
                    l’anglais, le vocabulaire y est sans cesse mixé et mouvant devenant un argot typique qui donne aux
                    conversations ivoiriennes toute leur saveur. Akwaba dans les rues de Côte d’Ivoire.

                    <br/><br/>
                    <table className={"table-auto w-full"}>
                        <thead>
                        <tr className={"bg-bleu-marine text-white"}>
                            <th className={"px-4 py-2 border border-slate-200"}>
                                Expression
                            </th>
                            <th className={"px-4 py-2 border border-slate-200"}>
                                Définition
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {langageDeRue.map((item, index) => (
                            <tr key={index}>
                                <td className={cn("px-4 py-2 border border-slate-200 font-bold", {
                                    "bg-slate-100": index % 2 === 0
                                })}>
                                    {item.expression}
                                </td>
                                <td className={cn("px-4 py-2 border border-slate-200", {
                                    "bg-slate-100": index % 2 === 0
                                })}>
                                    {item.definition}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </AwesomeCard>
            </SectionPage>

        </div>
    );
}
